import React, { Component } from 'react';
// import { Segment, Container, Grid, Header, List, Image, Divider } from 'semantic-ui-react';
// import icon from '../favicon.ico'
import { getTahunAnggaran } from '../_utils/localstorage';
export default class Footer extends Component {
   render() {
      return (
         <div>
            <div className="footer">
               <div style={{
                     marginTop:'0px',
                     color:'#fff',
                     padding:'15px 0px',
                     backgroundColor:'#000',
               }}>
                  <span style={{marginLeft:'20px', textAlign:'left'}}>
                     &copy; Developed and maintained by <a href="http://bimajaya.co.id">BIMA JAYA </a>
                     {getTahunAnggaran() &&
                        `[ data saat ini tahun anggaran ${ getTahunAnggaran() }]` 
                     }
                  </span>
               </div>
            </div>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js